exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host{height:100%}md-sidenav-layout.container{height:100%;width:100%}.sidenav>a{display:block;text-decoration:none;color:#2e2e2e}.sidenav>a,.sidenav>h3{margin:0;padding:5px 10px}.sidenav>a.router-link-active{background-color:#69c;font-weight:700;color:#fff}md-sidenav-layout>.content{display:block;padding-left:5px;width:85%;height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./script/shared/moduleroot/component.css
 ** module id = 378
 ** module chunks = 0 1
 **/